import React, { useState } from "react";
import { motion } from "framer-motion";
import { ClipboardCheck, HeartPulse, HardHat, ClipboardList, FlaskConical, Dumbbell, Truck, Accessibility } from "lucide-react";
import { useLang } from "../i18n";
import PreRideCheck from "../components/safety/PreRideCheck";
import SelfCheck from "../components/safety/SelfCheck";
import StandardsGuide from "../components/safety/StandardsGuide";
import NearMissLog from "../components/safety/NearMissLog";
import FitnessGuide from "../components/safety/FitnessGuide";
import ContextGuide from "../components/safety/ContextGuide";
import ParaSafety from "../components/safety/ParaSafety";
import Sources from "../components/safety/Sources";

const tabsDef = [
  { id: "preride", icon: ClipboardCheck },
  { id: "selfcheck", icon: HeartPulse },
  { id: "standards", icon: HardHat },
  { id: "fitness", icon: Dumbbell },
  { id: "context", icon: Truck },
  { id: "para", icon: Accessibility },
  { id: "log", icon: ClipboardList },
];

export default function Safety() {
  const { t } = useLang();
  const [tab, setTab] = useState("preride");

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 md:py-16">
      <div className="flex items-center gap-2 instrument-label text-sonne">
        <FlaskConical size={14} /> HFACS-Eq · Eq-Safety Model
      </div>
      <h1 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight">{t.safety.title}</h1>
      <p className="mt-4 text-wachs-dim max-w-2xl leading-relaxed">{t.safety.sub}</p>

      {/* Tabs */}
      <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2 border border-bronze/20 rounded-lg p-1.5 bg-tiefsee/50">
        {tabsDef.map((tb) => {
          const Icon = tb.icon;
          const active = tab === tb.id;
          return (
            <button
              key={tb.id}
              onClick={() => setTab(tb.id)}
              data-testid={`safety-tab-${tb.id}`}
              className={`relative flex items-center justify-center gap-2 py-2.5 px-2 rounded-md text-sm transition-colors ${active ? "text-nacht" : "text-wachs-dim hover:text-wachs"}`}
            >
              {active && <motion.span layoutId="safety-tab-bg" className="absolute inset-0 bg-sonne rounded-md" transition={{ type: "spring", stiffness: 400, damping: 32 }} />}
              <span className="relative flex items-center gap-2"><Icon size={16} /> <span className="hidden sm:inline">{t.safety.tabs[tb.id]}</span></span>
            </button>
          );
        })}
      </div>

      {/* Panel */}
      <div className="mt-8">
        <motion.div key={tab} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}>
          {tab === "preride" && <PreRideCheck />}
          {tab === "selfcheck" && <SelfCheck />}
          {tab === "standards" && <StandardsGuide />}
          {tab === "fitness" && <FitnessGuide />}
          {tab === "context" && <ContextGuide />}
          {tab === "para" && <ParaSafety />}
          {tab === "log" && <NearMissLog />}
        </motion.div>
      </div>

      <Sources />
    </div>
  );
}
